import { createSlice } from "@reduxjs/toolkit"
import { LoginThunk, signOut } from "./thunk/actionThunk";

const initialState: any = {
    plToken: null,
    userData: {}
}

export const authorizationSlice = createSlice({
    name: 'authorization',
    initialState,
    reducers: {},
    extraReducers: (builder: { addCase: (arg0: any, arg1: { (state: any, action: any): void; (state: any, action: any): void; (state: any, action: any): void; (state: any, action: any): void; }) => void; }) => {
        builder.addCase(signOut.fulfilled, (state, action) => {
            state.loading = false;
            state.userData = {};
            state.token = null;
        })
        builder.addCase(LoginThunk.pending, (state, action) => {
            state.loading = true;
            state.loginFailed = false
        })
        builder.addCase(LoginThunk.fulfilled, (state, action) => {
            const { accessToken, userDetails } = action.payload;
            state.token = accessToken;
            state.userData = userDetails;
            state.loading = false;
            state.loginFailed = false
        })
        builder.addCase(LoginThunk.rejected, (state, action) => {
            state.loading = false;
            state.loginFailed = true
        })
    },
})
export default authorizationSlice;